import { render, staticRenderFns } from "./SubmissionLine.vue?vue&type=template&id=40a85a7a&scoped=true&"
import script from "./SubmissionLine.vue?vue&type=script&lang=js&"
export * from "./SubmissionLine.vue?vue&type=script&lang=js&"
import style0 from "./SubmissionLine.vue?vue&type=style&index=0&id=40a85a7a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40a85a7a",
  null
  
)

export default component.exports